import { render, staticRenderFns } from "./RxPanel.vue?vue&type=template&id=37ea7702"
import script from "./RxPanel.vue?vue&type=script&lang=js"
export * from "./RxPanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports